export const VEHICLE_TYPE = {
  FRIGO_TRUCK: 'TRUCK_40_FRIGO'
}
